// Профиль текущего пользователя и его предпочтения.
// Вынесено из api.ts (Фаза 1, разбор клиента по доменам).

import { request } from "./client";
import { type PlayerGender } from "./common";

export type UiThemePreference = "SYSTEM" | "DARK" | "LIGHT" | "SEPIA";
export interface Me {
  id: string;
  telegramUserId: number;
  displayName: string;
  username?: string;
  themePreference: UiThemePreference;
  playerGender: PlayerGender;
  timeZoneId?: string;
}

export const meApi = {
  me: () => request<Me>("/api/me"),
  updateThemePreference: (theme: UiThemePreference) =>
    request<Me>("/api/me/preferences/theme", {
      method: "PUT",
      body: JSON.stringify({ theme }),
    }),
  updatePlayerGender: (gender: PlayerGender) =>
    request<Me>("/api/me/preferences/gender", {
      method: "PUT",
      body: JSON.stringify({ gender }),
    }),
  updateTimeZone: (timeZoneId: string) =>
    request<Me>("/api/me/preferences/timezone", {
      method: "PUT",
      body: JSON.stringify({ timeZoneId }),
    }),
};
